export default "__VITE_ASSET__DgY$9f5y__"